import './template-entry-list-item.scss';

import { isEmpty, kebabCase } from 'lodash';
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';

import { getTemplateMinuteLength } from '../../data/data/utils';
import { TemplateEntryAppointmentItemDataFragment } from '../../data/types/api/graphql';
import { formatTimeSpanToTime } from '../../data/utils/date.utils';
import { makeKeyDownHandler } from '../../data/utils/make-key-down-handler';
import { Button, ButtonIcon, ButtonType } from '../button/button';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';

export enum TemplateEntryListItemType {
  DEFAULT = 'DEFAULT',
}

type TemplateEntryAppointmentListItemProps = {
  type?: TemplateEntryListItemType;
  templateEntryAppointmentItem: TemplateEntryAppointmentItemDataFragment;
  actions?: {
    icon?: ButtonIcon;
    onClick: (value: string) => void;
  }[];
  onClick?: (value: TemplateEntryAppointmentItemDataFragment) => void;
};

export function TemplateEntryAppointmentListItem({
  templateEntryAppointmentItem,
  actions = [],
  onClick,
  ...props
}: TemplateEntryAppointmentListItemProps) {
  const type = useMemo(() => {
    if (props.type) {
      return props.type;
    }

    return kebabCase(templateEntryAppointmentItem.type);
  }, [props.type, templateEntryAppointmentItem.type]);

  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(templateEntryAppointmentItem),
        onKeyDown: makeKeyDownHandler(() =>
          onClick(templateEntryAppointmentItem)
        ),
      };
    }

    return {};
  }, [templateEntryAppointmentItem, onClick]);

  return (
    <div
      {...attributes}
      className={`template-entry-list-item template-entry-list-item--${kebabCase(
        type
      )}`}
    >
      <div className="template-entry-list-item__time">
        <p>
          {formatTimeSpanToTime(templateEntryAppointmentItem.minuteStartTime)} -{' '}
          {formatTimeSpanToTime(templateEntryAppointmentItem.minuteEndTime)}
        </p>
      </div>
      <div className="template-entry-list-item__content">
        <p>
          <CustomFormattedMessage
            id={`template.entry-type-${kebabCase(
              templateEntryAppointmentItem.type
            )}.title`}
            values={{
              name: templateEntryAppointmentItem.name,
              minutes: getTemplateMinuteLength(templateEntryAppointmentItem),
            }}
          />
        </p>
      </div>

      {!isEmpty(actions) && (
        <div className="template-entry-list-item__action">
          {actions.map(option => (
            <Button
              key={uuid()}
              type={ButtonType.TRANSPARENT}
              icon={option.icon}
              onClick={() => option.onClick(templateEntryAppointmentItem.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
